import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { XAxis } from "../chart/XAxis";
import { YAxis } from "../chart/YAxis";

import "./PhoneHeartRate.css";

function PhoneHRV({ data, day, mode, selection = [] }) {
  const width = 300;
  const height = 90;
  const [marginLeft, marginRight, marginTop, marginBottom] = [21, 15, 15, 15];
  const innerWidth = width - marginLeft - marginRight;
  const innerHeight = height - marginTop - marginBottom;

  var timeKey = mode === "live" ? "timepoint" : "time";

  var minDay;
  var maxDay;
  if (mode === "live") {
    minDay = new Date(data[data.length - 1][timeKey]);
    maxDay = new Date(data[data.length - 1][timeKey]);
    minDay.setMinutes(0);
    minDay.setSeconds(0);
    minDay.setMilliseconds(0);
    maxDay.setHours(maxDay.getHours() + 1);
    maxDay.setMinutes(0);
    maxDay.setSeconds(0);
    maxDay.setMilliseconds(0);
  } else if (mode === "1D") {
    minDay = new Date(day)
    maxDay = new Date(day)
    maxDay.setDate(maxDay.getDate() + 1);
    if (selection.length > 0) {
      minDay = selection[0];
      maxDay = selection[1];
    }
  }
  data = data.filter(
    (x) => new Date(x[timeKey]) >= minDay && new Date(x[timeKey]) <= maxDay
  );

  const xScale = useMemo(() => {
    return d3
      .scaleTime()
      .domain([minDay, maxDay])
      .range([marginLeft, marginLeft + innerWidth])
      .nice();
  }, [innerWidth, marginLeft, maxDay, minDay]);

  const yScale = useMemo(() => {
    const min = d3.min(data, (d) => d.rmssd);
    const max = d3.max(data, (d) => d.rmssd);
    return d3
      .scaleLinear()
      .domain([min, max])
      .range([innerHeight + marginBottom, marginBottom])
      .nice();
  }, [data, innerHeight, marginBottom]);

  const color = data.map((x) => {
    if (x.stress_index === null || x.stress_index === undefined) {
      return "#939393";
    }

    if (x.color === "green") {
      return "#5AD876"; //green
    } else if (x.color === "yellow") {
      return "#E8D286"; //yellow
    } else if (x.color === "red") {
      return "#E88686"; //red
    } else {
      return "#9a9a9a";
    }
  });


  return (
    <>
      {data && (
        <div className="heartRate_chart">
          <div className="heartRate_chart__Chart">
            <svg className="Sparkline hrv" viewBox={`0 0 ${width} ${height}`}>
              <g>
                {data.map((d, i) => (
                  <g>
                    <rect
                      x={xScale(new Date(d[timeKey]))}
                      value={d[timeKey]}
                      y={yScale(d.rmssd)}
                      height={innerHeight - yScale(d.rmssd) + marginBottom}
                      width={1.4}
                      key={`rect-${d[timeKey]}-${i}`}
                      className={d[timeKey]}
                      fill={color[i]}
                    ></rect>
                    {(mode === "live" && i === data.length - 1) && (
                      <animate
                        attributeType="CSS"
                        attributeName="opacity"
                        from="1"
                        to="0"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    )}
                  </g>
                ))}

                {/*   
                <line
                  x1={marginLeft}
                  x2={innerWidth + marginRight}
                  y1={yScale(4.908595)+ marginTop}
                  y2={yScale(4.908595)+ marginTop}
                  stroke="black"
                  style={{
                    stroke: "black",
                    strokeWidth: "2px",
                    strokeDasharray: "5 5",
                  }}
                  className="line-chart__line"
                /> */}
              </g>
              <XAxis
                xScale={xScale}
                innerHeight={innerHeight + marginBottom}
                ticks={10}
              ></XAxis>
              <YAxis yScale={yScale} margin={marginLeft} ticks={4}></YAxis>
            </svg>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(PhoneHRV);
